import { LitElement, html } from 'lit';
import styles from './fit-button-bar.css';

class FitButtonBar extends LitElement {
  static get is() { return 'fit-button-bar'; }

  static get styles() { return styles; }

  render() {
    return html`
      <slot class="button-bar__buttons"></slot>
    `;
  }

  static get properties() {
    return {
      ticking: {
        type: Boolean,
      },
      loaded: {
        type: Boolean,
      },
      windowHeight: {
        type: Number,
      },
    };
  }

  constructor(props) {
    super(props);
    this.ticking = false;
    this.loaded = false;
    this.windowHeight = 0;

    this.checkVisibility();

    this.init = this.init.bind(this);
    this.requestTick = this.requestTick.bind(this);
    this.checkVisibility = this.checkVisibility.bind(this);
    this.updateWindowInformation = this.updateWindowInformation.bind(this);
  }

  connectedCallback() {
    super.connectedCallback();
    this.init();

    window.addEventListener('resize', this.updateWindowInformation);
    document.addEventListener('DOMContentLoaded', this.init, false);
    window.addEventListener('load', this.init, false);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  checkVisibility() {
    window.pageYOffset > this.windowHeight * 1.25
      ? this.setAttribute('visible', '') : this.removeAttribute('visible');
    this.ticking = false;
  }

  requestTick() {
    if (!this.ticking) {
      window.requestAnimationFrame(this.checkVisibility);
      this.ticking = true;
    }
  }

  updateWindowInformation() {
    this.windowHeight = window.innerHeight;
  }

  init() {
    if (!this.loaded) {
      this.updateWindowInformation();
      this.checkVisibility();
      window.addEventListener('scroll', this.requestTick);
    }
  }
}

customElements.define(FitButtonBar.is, FitButtonBar);
